import { useEffect, useState } from 'react'
import './leagues-page.styles.scss';
import { useSelector } from 'react-redux'
import { Route, Routes } from 'react-router-dom';
import { listenToCollection } from '@/utils/getDataFromDb';
import ManagerShell from '@/components/HOME/manager-shell/manager-shell.component';
import LeagueList from '@/components/HOME/league-list/league-list.component';
import JoinLeague from '@/components/HOME/join-league/join-league.component';

// /leagues: the leagues you're in and the ones you can join.
// /leagues/:leaguePath: choose a team in one league.
const LeaguesPage = () => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ leagues, setLeagues ] = useState(null);

    useEffect(() => {
        if (!userProfile) return;
        let unsub;
        listenToCollection({
            'path': 'leagues',
            'callback': setLeagues,
            'handleListener': (u) => { unsub = u; },
        });
        return () => { if (unsub) unsub(); }
    }, [userProfile])

    return (
        <ManagerShell>
            <div className='leagues-page'>
                <Routes>
                    <Route path='' element={<LeagueList leagues={leagues} appId={userProfile?.appId} />}></Route>
                    <Route path=':leaguePath' element={<JoinLeague leagues={leagues} appId={userProfile?.appId} />}></Route>
                </Routes>
            </div>
        </ManagerShell>
    )
}

export default LeaguesPage
